export default "__VITE_ASSET__BoPYU2fp__"